export default {
  title: "系统管理",
  logo: "../../../assets/image/logo_1.png",
  author: "",
  whiteList: ["/login", "/404", "/401", "/lock", "/chorme"],
  lockPage: '/lock',
  tokenTime: 6000,
  info: {
    title: "系统管理",
    list: [
      '文件管理',
      '日志管理',
      '服务监控',
      '注册中心',
      'kafka 消息队列'
    ]
  },
  wel: {
    title: '系统管理',
    list: [
      '文件管理',
      '日志管理',
      '服务监控',
      '注册中心',
      'kafka 消息队列'
    ]
  }
}
